import { graphql } from 'react-relay';

export const fundsManagerFragment = graphql`
  fragment FundsManager_component on FundsManager {
    managername
    managercompany
    advisortext
    picture {
      ...ProfilePicture_picture
    }
    phone
    email
  }
`;
